
import { Component, Vue, Prop,Watch } from 'vue-property-decorator'
import goodsCard from './goodsCard.vue'
import { Getter } from 'vuex-class'
import {
  getCyStoreGoodsList,
  ShopGoodsInfoDto,
  getStoreShoppingCart
} from '@/api/industryMall'

@Component({
  name: 'goodsList',
  components: {
    goodsCard
  }
})
export default class goodsList extends Vue {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  @Prop({default:''}) keyword!:string

  sortArr = [
    { sortName: '综合', sortId: 1, sortWay: false },
    { sortName: '销量', sortId: 2, sortWay: false },
    { sortName: '价格', sortId: 3, sortWay: true }
  ]
  priceSort = false
  priceSortShow = false
  loading = false
  finished = false
  refreshing = false
  list: ShopGoodsInfoDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 10,
    partnerCompanyId: '',
    companyId:'',
    keyword: '',
    /**
     * 1 综合排序
     * 2 销量排序
     * 3 价格排序
     */
    sort: undefined,
    sortWay: undefined
  }
  // 排序项
  sortId = null

  isLoading = false
  listScrollTop = 0

  @Watch('keyword',{immediate:true})
  handleKeyword(newVal:string) {
    this.params.partnerCompanyId = this.partnerCompanyId
    this.params.keyword = newVal
    this.params.companyId = this.companyId
    this.params.pageIndex = 1
    this.list = []
    this.getCyStoreGoodsList()

  }

  handleScroll (event: any) {
    this.listScrollTop = event.target.scrollTop
  }

  activated() {
    document.querySelector('.goods-refresh') && document.querySelector('.goods-refresh').scrollTo(0, this.listScrollTop)
    this.refreshShoppingGoodsCount()
  }

  refreshShoppingGoodsCount () {
    getStoreShoppingCart({
      partnerCompanyId: this.partnerCompanyId,
      pageIndex: 1,
      pageSize: 100
    }).then((res) => {
      const shoppingGoods = []
      res.data.records.forEach(shop => {
        shoppingGoods.push(...shop.goodsPackageList)
      })
      const goods = []
      shoppingGoods.forEach(good => {
        if (Number(good.isValid)) {
          goods.push({
            goodsId: good.goodsId,
            packageId: good.packageId,
            orderQuantity: Number(good.orderQuantity),
            goodsName: good.goodsName
          })
        }
      })
      this.list.forEach(good => {
        // if (!good.isMultiSpec && good.packageList.length === 1) {
        //   const targetGood = goods.find(id => id.goodsId === good.goodsId && id.packageId === good.packageList[0].packageId)
        //   if (targetGood) {
        //     good.packageList[0].orderQuantity = targetGood.orderQuantity
        //   } else {
        //     // 购物车删除的商品
        //     good.packageList[0].orderQuantity = 0
        //   }
        // }
        if (!good.isMultiSpec) {
          good.packageList.forEach((pack: any, packIndex) => {
            const targetGood = goods.find(id => id.goodsId === pack.goodsId && id.packageId === good.packageList[packIndex].packageId)
            if (targetGood) {
              good.packageList[packIndex].orderQuantity = targetGood.orderQuantity
            } else {
              // 购物车删除的商品
              good.packageList[packIndex].orderQuantity = 0
            }
          })
        }
      })
      console.log('refreshShoppingGoodsCount', goods)
    })
  }

  onLoad() {
    this.params.pageIndex++
    this.getCyStoreGoodsList()
  }

  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getCyStoreGoodsList()
  }

  /**
   * 获取商品列表
   */
  getCyStoreGoodsList() {

    getCyStoreGoodsList({ ...this.params })
      .then((res) => {
        if (this.refreshing) {
          this.list = []
        }
        this.list = this.list.concat((res.data && res.data.records) || [])
        if (this.params.pageIndex >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.finished = true
      })
      .finally(() => {
        this.isLoading = true
        this.loading = false
        this.refreshing = false
      })
  }

  sortData(type: number) {
    this.isLoading = false
    if (type === 3) {
      this.priceSortShow = true
      this.priceSort = !this.priceSort
      this.params.sortWay = this.priceSort ? 1 : 2
    } else {
      this.priceSortShow = false
    }

    this.params.sort = type
    this.params.pageIndex = 1
    this.list = []
    this.getCyStoreGoodsList()
  }
}
